import { render } from "./Search.vue?vue&type=template&id=3f66a0f6&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=3f66a0f6&scoped=true&lang=scss"
import "./Search.vue?vue&type=style&index=1&id=3f66a0f6&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f66a0f6"]])

export default __exports__